import axios from 'axios'

const shouldUnwrapLegacyData = (url: any) => {
    if (typeof url !== 'string') return false
    return /(^|\/)subscription-plans\/?$/.test(url)
}

const normalizeGetResponse = (response: any, url: any) => {
    if (!shouldUnwrapLegacyData(url)) return response

    const payload = response?.data?.data
    const hasLegacyPlanShape =
        payload &&
        typeof payload === 'object' &&
        Array.isArray(payload.headers) &&
        Array.isArray(payload.head_features)

    if (!hasLegacyPlanShape) return response

    return {
        ...response,
        data: payload
    }
}

const normalizePostResponse = (response: any) => {
    const payload = response?.data
    const nested = payload?.data
    if (!payload || typeof payload !== 'object' || !nested || typeof nested !== 'object' || Array.isArray(nested)) {
        return response
    }

    return {
        ...response,
        data: {
            ...payload,
            ...nested
        }
    }
}

export const getRequest = async (url: any) => {
    const result = await axios
        .get(url, {
            headers: {
                //   Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })
        .then((response) => normalizeGetResponse(response, url))
        .catch((error) => {
            throw error.response?.data || error.message
        })
    return result
}

export const PostRequest = async (url: any, data: any) => {
    const result = await axios
        .post(url, data, {
            headers: {
                Authorization: "Bearer "+localStorage.getItem('token'),
                Accept: 'application/json'
            }
        })
        .then((response) => normalizePostResponse(response))
        .catch((error) => error.response)
    return result
}
